import React, { Component } from "react";
import { I18nextProvider, Translation } from "react-i18next";
import { I18nProvider } from "gatsby-i18n";
import setupI18next from "../../i18next";
import { CustomI18nextProvider } from "../../contexts/CustomI18nextContext";
import { PageContextProvider } from "../../contexts/PageContext";

import enTranslation from "../../locales/en/translation.json";
import auTranslation from "../../locales/au/translation.json";
import thTranslation from "../../locales/th/translation.json";
import th_enTranslation from "../../locales/th_en/translation.json";
import idTranslation from "../../locales/id/translation.json";
import id_enTranslation from "../../locales/id_en/translation.json";

const localesNSContent = {
  en: enTranslation,
  au: auTranslation,
  th: thTranslation,
  th_en: th_enTranslation,
  id: idTranslation,
  id_en: id_enTranslation,
};

// const lngFormat = locale => locale.replace(/-[a-z]{2}$/, e => e.toUpperCase());

const WithI18next =
  (options = {}) =>
  (Comp) => {
    class I18nHOC extends Component {
      constructor(props) {
        super(props);

        const { pageContext, content } = props;
        this.state = {
          ...options,
          ns: "translation",
          content: content ? content : localesNSContent[pageContext.lang],
        };

        this.i18n = setupI18next(pageContext);
        this.activateLng();
      }

      activateLng = () => {
        const { pageContext } = this.props;
        const { content } = this.state;
        this.parseFromContext(content);
        this.i18n.changeLanguage(pageContext.lang);
      };

      parseFromContext = (content) => {
        const { pageContext } = this.props;
        if (content) {
          const lng = pageContext.lang;
          if (!this.i18n.hasResourceBundle(lng, "translation")) {
            this.i18n.addResourceBundle(lng, "translation", content);
          }
        }
      };

      componentDidUpdate(prevProps) {
        if (this.props.pageContext.lang !== prevProps.pageContext.lang) {
          this.activateLng();
        }
      }

      render() {
        const { ns } = this.state;
        return (
          <I18nextProvider i18n={this.i18n} defaultNS={ns}>
            <I18nProvider {...this.props.pageContext}>
              <Translation>
                {(t) => (
                  <CustomI18nextProvider
                    t={t}
                    lang={this.props.pageContext.lang}
                  >
                    <PageContextProvider
                      pathname={this.props.location.pathname}
                      footerMenus={this.props.pageContext.footerMenus}
                      latestPosts={this.props.pageContext.latestPosts}
                    >
                      <Comp
                        {...this.props}
                        t={t}
                        lang={this.props.pageContext.lang}
                      />
                    </PageContextProvider>
                  </CustomI18nextProvider>
                )}
              </Translation>
            </I18nProvider>
          </I18nextProvider>
        );
      }
    }

    return I18nHOC;
  };

export default WithI18next;
